import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { Campaign } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export interface UnpublishCampaignLandingPageParams {
  id: string;
}

export const unpublishCampaignLandingPage = async (
  params: UnpublishCampaignLandingPageParams,
): Promise<Campaign> => {
  return await tinctApi.campaigns.unpublishLandingPage(params.id);
};

/** NEW-origin campaigns only: takes the hosted page down. */
export const useUnpublishCampaignLandingPage = (
  options?: Omit<
    UseMutationOptions<Campaign, ApiError, UnpublishCampaignLandingPageParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: unpublishCampaignLandingPage,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      queryClient.invalidateQueries({ queryKey: ['campaign', args[1].id] });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
